import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { AppRoutes } from '../paths';
import IntroPage from '../../pages/intro-page';
import { AuthOutlet } from '../../auth/auth-route';
import LandingPage from '../../pages/landing-page';
import { PageWrapper } from '../../components/page-wrapper';
import RecommendationPageV2 from '../../pages/recommendation-pageV2';
import { ResourceManagerRoute } from '../../auth/route-guards/resource-manager-route';
import { YourLearningWrapper } from '../../components/your-learning/your-learning-page-wrapper';
// ----------------------------------------------------------------------

const ProfileSelectionPage = lazy(() => import('../../pages/quiz/profile-selection-page'));
const QuestionPage = lazy(() => import('../../pages/quiz/question-page'));
const RecommendationPage = lazy(() => import('../../pages/recommendation-page'));
const LibraryPage = lazy(() => import('../../pages/library-page'));
const ProgressPage = lazy(() => import('../../pages/progress-page'));
const BookmarksPage = lazy(() => import('../../pages/bookmarked-resources-page'));
const ResourceManagerPage = lazy(() => import('../../pages/resource-manager-page'));
const TopicManagerPage = lazy(() => import('../../pages/topic-manager-page'));
const SkillStatsPage = lazy(() => import('../../pages/skill-stats-page'));

// ----------------------------------------------------------------------

export const privateRoutes = [
  {
    path: AppRoutes.LANDING_PAGE,
    element: (
      <Suspense fallback={<></>}>
        <AuthOutlet />
      </Suspense>
    ),
    children: [
      {
        element: <PageWrapper />,
        children: [
          {
            index: true,
            element: <LandingPage />,
          },
          {
            path: AppRoutes.QUIZ_PROFILE_SELECTION,
            element: <ProfileSelectionPage />,
          },
          {
            path: AppRoutes.QUIZ_QUESTION,
            element: <QuestionPage />,
          },
          {
            path: AppRoutes.LIBRARY,
            element: <LibraryPage />,
          },
          {
            element: <YourLearningWrapper />,
            path: AppRoutes.YOUR_LEARNING,
            children: [
              {
                path: AppRoutes.BOOKMARKS,
                element: <BookmarksPage />,
              },
              {
                index: true,
                element: (
                  <Navigate
                    to={AppRoutes.BOOKMARKS}
                    replace
                  />
                ),
              },
              {
                path: AppRoutes.RECOMMENDATIONS,
                element: <RecommendationPage />,
              },
              {
                path: AppRoutes.RECOMMENDATIONSV2,
                element: <RecommendationPageV2 />,
              },
              {
                path: AppRoutes.STATS,
                element: <SkillStatsPage />,
              },
              {
                path: AppRoutes.PROGRESS,
                element: <ProgressPage />,
              },
            ],
          },
          {
            path: AppRoutes.INTRO_PAGE,
            element: <IntroPage />,
          },
          {
            element: <ResourceManagerRoute />,
            children: [
              {
                path: AppRoutes.RESOURCE_MANAGER,
                element: <ResourceManagerPage />,
              },
              {
                path: AppRoutes.TOPIC_MANAGER,
                element: <TopicManagerPage />,
              },
            ],
          },
        ],
      },
    ],
  },
];
